import { selectConversationId } from '../../common/selectors/chat';
import { selectWidgetSessionId } from '../../common/selectors/widgetSession';
import { biLogger } from '../biLogger';
import { BiEventLogger } from '../types';

type BiData = {
  message: string;
  data: Record<string, any>;
};

export const logChatbotGeneralClientLog: BiEventLogger<BiData> = (state, { message, data }) => {
  let messages = [];
  if (data.messages) {
    messages = data.messages.map((msg: any) => ({ id: msg.id, text: msg.text, html: msg.html }));
  }
  biLogger.chatbotGeneralClientLog({
    message,
    session_id: selectWidgetSessionId(state),
    conversation_id: selectConversationId(state),
    data: JSON.stringify({ ...data, messages }),
    chatbot_view: undefined,
  });
};
